import * as React from 'react'

export type Size =
  | {
      width: number
      height: number
    }
  | undefined

function getSize(el: HTMLElement) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: window.innerHeight
  }
}

function useSize(ref: React.RefObject<HTMLElement>): Size {
  const [size, setSize] = React.useState<Size>()
  const handleResize = React.useCallback(() => {
    if (ref.current) {
      const nextSize = getSize(ref.current)
      setSize(size => ({
        ...nextSize
      }))
    }
  }, [ref])
  React.useLayoutEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function() {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref])

  return size
}

export default useSize
